import { SeatOrgKind } from "@sx/protocol/fleet/supervision";
import { Navigate, createFileRoute } from "@tanstack/react-router";

import { FleetPage } from "../../../workspaces/fleet/pages/FleetPage";
import { useSeat } from "../../../workspaces/fleet/seat";

export const Route = createFileRoute("/_console/p/$org/$project/deploy/stations/$stationId")({
  component: SupervisedStation,
});

/** One station's live supervision, at its own address.
 *
 * A station id is unique in the fleet, so which station is being watched is a coordinate
 * and not a filter that happened to select one row — and a person who sends the link
 * sends the station.
 *
 * Org kind gates the ADDRESS, not just the nav entry: a teleop vendor has no fleet of
 * their own, so this is not a hidden page for them; their home is the help queue. */
function SupervisedStation() {
  const seat = useSeat();
  const { stationId, ...address } = Route.useParams();
  const navigate = Route.useNavigate();
  if (seat.orgKind === SeatOrgKind.TELEOP_VENDOR) return <Navigate to="/teleoperators" replace />;
  return (
    <FleetPage
      station={stationId}
      onStationChange={(next, replace = false) =>
        void navigate({
          to: "/p/$org/$project/deploy/stations/$stationId",
          params: { ...address, stationId: next },
          replace,
        })
      }
    />
  );
}
